import styled from 'styled-components';
import type { AlignmentValue } from '@elfsight/configurator-contracts';
import { Typography } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';

export function Header({ isMobile }: { isMobile?: boolean }) {
  const { headerTitle, headerCaption, headerAlignment } = useSettings();

  if (!headerTitle && !headerCaption) {
    return null;
  }

  return (
    <Container _alignment={headerAlignment}>
      {headerTitle && (
        <Typography
          textStyle={{ fontSize: isMobile ? 24 : 36, fontWeight: 'bold' }}
        >
          {headerTitle}
        </Typography>
      )}

      {headerCaption && (
        <Typography
          textStyle={{ fontSize: 15 }}
          dangerouslySetInnerHTML={{ __html: headerCaption }}
        />
      )}
    </Container>
  );
}

const Container = styled.div<{ _alignment: AlignmentValue }>`
  text-align: ${({ _alignment }) => _alignment};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
